// export const API_BASE_URL = "https://dev.partechsa.com/api";
export const API_BASE_URL = "https://darkgrey-snail-484995.hostingersite.com/api";
// export const API_BASE_URL = "http://127.0.0.1:8000/api";
// export const BASE_IMAGE_URL = "https://dev.partechsa.com/storage/";
export const BASE_IMAGE_URL = "https://darkgrey-snail-484995.hostingersite.com/storage/";
// export const BASE_IMAGE_URL = "http://127.0.0.1:8000/storage/";